(() => {
  const q = (root, selector) => root?.querySelector(selector);
  const qa = (root, selector) => [...(root?.querySelectorAll(selector) || [])];

  const furavoraSearchTitles = {
    '1pc-automatic-dog-ball-launcher-toy-included-6-tennis-balls-dog-with-3-adjustable-launch-distance-interactive-ball-thrower-fetch-machine-for-small-medium-dogs': 'Furavora Auto Ball Launcher',
    'cat-comb-massage-pet-magic-combs-hair-removal-cat-and-dog-brush-pets-grooming-cleaning-supplies-scratcher': 'Furavora Massage Grooming Comb',
    'chest-strap-jacket-cotton-padded-coat': 'Furavora Quilted Winter Jacket',
    'cosplay-pet-supplies-standing-outfit-funny-dog-clothes-upright-outfit-halloween-christmas-dress-up-pet-outfit': 'Furavora Upright Hero Costume',
    'cute-fruit-dog-clothes-for-small-dogs-hoodies-winter-warm-fleece-pet-clothing-puppy-cat-costume-coat-for-french-chihuahua-outfit': 'Furavora Fruity Fleece Hoodie',
    'dinosaur-skeleton-pet-costume': 'Furavora Dino Skeleton Costume',
    'dog-harness-anti-loose-adjustable-dog-leash': 'Furavora Adjustable Walk Set',
    'dogs-cats-pets-brush-pet-bath-brush-cleaning-brushes-long-handle-shower-brush-pet-supplies-cat-dog-pet-grooming-comb-for-pet-products': 'Furavora Bath Shampoo Brush',
    'dot-turtleneck-dog-bottoming-shirt': 'Furavora Polka-Dot Turtleneck',
    'electric-lice-remover': 'Furavora Electric Lice Comb',
    'electric-pet-hair-portable-pet-massage-cleaning-vacuum-cleaner': 'Furavora Portable Grooming Vacuum',
    'fashionable-high-end-multi-color-dog-harness': 'Furavora AirMesh Harness Set',
    'halloween-pet-costume-pet-dog-funny-clothes-adjustable-dog-cosplay-costume-scary-costume-party-gatherings': 'Furavora Halloween Rider Costume',
    'interactive-electric-induction-snake-funny-cat-toy': 'Furavora Smart Snake Toy',
    'led-pet-safety-halo-style-collar': 'Furavora LED Halo Collar',
    'pet-dog-bed-warming-soft-sleeping-bag-cushion-puppy-kennel': 'Furavora Cozy Sleeping Nest',
    'pet-hair-remover-mitt-pet-hair-remover-gloves-deshedding-brush-glove-for-dog-cat-rabbit-with-long-short-curly-hair': 'Furavora Deshedding Grooming Mitt',
    'pet-hair-remover-dog-cat-hair-remover-lint-cleaner-pro-fur-removal-tool-portable-carpet-scraper-fuzz-rollers-hairball-shaver-brush-for-carpets-car-mat-couch-pet-bed-furniture-rug': 'Furavora Reusable Fur Scraper',
    'shoulder-and-crossbody-pet-dog-backpack-small-dog-leash-handbag': 'Furavora Hands-Free Sling Carrier',
    'simulation-electric-funny-cat-simulation-fish': 'Furavora Flopping Fish Toy',
    'smart-laser-cat-teaser-toy-usb-charging': 'Furavora Smart Laser Teaser',
    'water-dispenser-is-mobile-and-unplugged-automatic-water-feeder-for-pets': 'Furavora Gravity Water Station',
    'yellow-outdoor-heavy-duty-foldable-practical-pet-stroller-dog-carrier-with-bicycle-tow': 'Furavora Stroller Bike Trailer'
  };

  const removedSearchHandles = new Set([
    'led-laser-electronic-rolling-pet-funny-cat-toy-ball'
  ]);

  const brandedSearchTitle = (product) => {
    const urlHandle = String(product?.url || '').split('/products/')[1]?.split(/[?#]/)[0] || '';
    const handle = product?.handle || urlHandle;
    if (furavoraSearchTitles[handle]) return furavoraSearchTitles[handle];
    const rawTitle = String(product?.title || '').replace(/\s+/g, ' ').trim();
    const words = rawTitle
      .split(/[|–—]/)[0]
      .split(' ')
      .map((word) => word.replace(/^[^a-z0-9]+|[^a-z0-9&-]+$/gi, ''))
      .filter((word) => word && !/^(furavora|pets?(?:-|$)|cats?(?:-|$)|dogs?(?:-|$)|product|products|supplies)/i.test(word))
      .slice(0, 3);
    if (words.length < 2) return 'Furavora Curated Essential';
    return `Furavora ${words.join(' ')}`;
  };

  const initTapFeedback = () => {
    document.addEventListener('pointerdown', (event) => {
      const target = event.target.closest('button, .button, .fv2-tool, .fv2-card__choose, .fv5-option-toggle, summary');
      if (!target || target.disabled) return;
      target.classList.remove('fv5-tap');
      void target.offsetWidth;
      target.classList.add('fv5-tap');
      window.setTimeout(() => target.classList.remove('fv5-tap'), 360);
    }, { passive: true });
  };

  const initSearch = () => {
    qa(document, '[data-fv2-search]').forEach((search) => {
      if (search.dataset.fv5Ready) return;
      search.dataset.fv5Ready = 'true';
      const input = q(search, '[data-fv5-search-input]');
      const results = q(search, '[data-fv5-search-results]');
      let timer = null;
      let controller = null;

      search.addEventListener('toggle', () => {
        // The v2 menu system locks the page for full-screen overlays. Search v5 is a compact dropdown.
        if (search.open) {
          requestAnimationFrame(() => {
            if (!document.querySelector('[data-fv2-menu][open]')) document.body.classList.remove('fv2-lock');
            input?.focus({ preventScroll: true });
          });
        }
      });

      const renderMessage = (message) => {
        if (!results) return;
        results.replaceChildren();
        const p = document.createElement('p');
        p.className = 'fv5-search-message';
        p.textContent = message;
        results.appendChild(p);
      };

      const renderProducts = (products) => {
        if (!results) return;
        results.replaceChildren();
        const visibleProducts = products.filter((product) => {
          const urlHandle = String(product?.url || '').split('/products/')[1]?.split(/[?#]/)[0] || '';
          const handle = product?.handle || urlHandle;
          return !removedSearchHandles.has(handle) && product?.available !== false;
        });
        if (!visibleProducts.length) {
          renderMessage('No quick matches. Press Enter to search the full catalog.');
          return;
        }
        visibleProducts.slice(0, 5).forEach((product) => {
          const a = document.createElement('a');
          a.className = 'fv5-search-result';
          a.href = product.url || '#';

          const image = document.createElement('img');
          const imageSource = typeof product.image === 'string'
            ? product.image
            : (product.image?.url || product.featured_image?.url || product.featured_image || '');
          image.src = imageSource || q(document, '.fv2-brand img')?.currentSrc || q(document, '.fv2-brand img')?.src || '';
          image.alt = '';
          image.loading = 'lazy';
          image.width = 72;
          image.height = 72;

          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = brandedSearchTitle(product);
          const meta = document.createElement('small');
          meta.textContent = 'View product';
          copy.append(title, meta);

          const arrow = document.createElement('b');
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          a.append(image, copy, arrow);
          results.appendChild(a);
        });
      };

      const loadSuggestions = async () => {
        const term = (input?.value || '').trim();
        if (!results) return;
        if (term.length < 2) {
          results.replaceChildren();
          return;
        }
        controller?.abort();
        controller = new AbortController();
        try {
          const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide`;
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('suggestion request failed');
          const data = await response.json();
          renderProducts(data?.resources?.results?.products || []);
        } catch (error) {
          if (error.name !== 'AbortError') renderMessage('Press Enter to search the full catalog.');
        }
      };

      input?.addEventListener('input', () => {
        clearTimeout(timer);
        timer = window.setTimeout(loadSuggestions, 180);
      });
      search.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        search.removeAttribute('open');
        q(search, 'summary')?.focus({ preventScroll: true });
      });
      document.addEventListener('pointerdown', (event) => {
        if (!search.open || search.contains(event.target)) return;
        search.removeAttribute('open');
      }, { passive: true });
      window.visualViewport?.addEventListener('resize', () => {
        if (search.open) input?.focus({ preventScroll: true });
      }, { passive: true });
    });
  };

  const iconMarkup = (kind) => {
    const icons = {
      color: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3c4.97 0 9 4.03 9 9a6 6 0 0 1-6 6H8a5 5 0 0 1-5-5c0-1.4.58-2.74 1.6-3.69l5.4-5.03A2.9 2.9 0 0 1 12 3Z" fill="currentColor" opacity=".22"></path><circle cx="8.2" cy="11" r="1.4" fill="currentColor"></circle><circle cx="12" cy="8.6" r="1.35" fill="currentColor"></circle><circle cx="15.7" cy="10.8" r="1.35" fill="currentColor"></circle><circle cx="10.8" cy="14.8" r="1.25" fill="currentColor"></circle></svg>',
      size: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 9V5h4M19 9V5h-4M5 15v4h4M19 15v4h-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8 12h8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>',
      bundle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5 12 4l8 4.5-8 4.5-8-4.5Zm0 3.8 8 4.5 8-4.5M4 16.1l8 4.5 8-4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
      style: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.4 5 5.6.8-4 3.9 1 5.5-5-2.7-5 2.7 1-5.5-4-3.9 5.6-.8L12 3Z" fill="currentColor"></path></svg>',
      bowl: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h16c-.6 5-3 8-8 8s-7.4-3-8-8Z" fill="currentColor" opacity=".25"></path><path d="M4 10h16c-.6 5-3 8-8 8s-7.4-3-8-8Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"></path><path d="M8 7.5h8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>',
      default: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="5" width="16" height="14" rx="3" fill="none" stroke="currentColor" stroke-width="2"></rect><path d="M8 10h8M8 14h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>'
    };
    return icons[kind] || icons.default;
  };

  const extractPackLabel = (value) => {
    const text = String(value || '').trim();
    const packMatch = text.match(/(?:^|\s)(?:x|×)\s*(\d+)(?:$|\s)/i) || text.match(/(\d+)\s*(?:pcs?|pieces?)/i) || text.match(/pack\s*of\s*(\d+)/i);
    if (packMatch) return `${packMatch[1]} PCS`;
    if (/\bset\b/i.test(text)) return 'SET';
    return '';
  };

  const extractPrimaryLabel = (value) => {
    const text = String(value || '').trim();
    const cleaned = text
      .replace(/(?:^|\s)(?:x|×)\s*\d+(?:$|\s)/ig, ' ')
      .replace(/\d+\s*(?:pcs?|pieces?)/ig, ' ')
      .replace(/pack\s*of\s*\d+/ig, ' ')
      .replace(/\bset\b/ig, ' ')
      .replace(/[()]/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
    return cleaned || text;
  };

  const inferOptionKind = (rawLabel, values) => {
    const label = String(rawLabel || '').toLowerCase();
    const hasPackValue = values.some((value) => extractPackLabel(value));
    if (label.includes('color') || label.includes('colour')) return hasPackValue ? 'bundle' : 'color';
    if (label.includes('pcs') || label.includes('quantity') || label.includes('qty') || label.includes('pack') || label.includes('bundle') || label.includes('set')) return 'bundle';
    if (label.includes('size') || label.includes('fit') || label.includes('specification')) return 'size';
    if (label.includes('style') || label.includes('character') || label.includes('variant')) return 'style';
    if (label.includes('bowl')) return 'bowl';
    if (hasPackValue) return 'bundle';
    return 'default';
  };

  const optionHeading = (kind, rawLabel) => {
    const label = String(rawLabel || '').trim();
    if (kind === 'bundle') return 'OPTION';
    return label.toUpperCase();
  };

  const formatSelectedValue = (kind, value) => {
    const primary = extractPrimaryLabel(value);
    const secondary = extractPackLabel(value);
    if (kind === 'bundle' && secondary) return `${primary} • ${secondary}`;
    return primary;
  };

  const decorateOptionLabel = (group, input, kind) => {
    const label = input.nextElementSibling;
    const swatch = label?.querySelector('.fv3-option__swatch');
    const textSpan = label?.querySelector('span:last-child');
    if (!label || label.dataset.fv5Decorated === 'true') return;
    label.dataset.fv5Decorated = 'true';
    const rawValue = input.value || textSpan?.textContent || '';
    const renderedValue = textSpan?.textContent?.replace(/\s+/g, ' ').trim() || '';
    const hasCuratedLabel = renderedValue && renderedValue.toLowerCase() !== String(rawValue).toLowerCase();
    const primaryLabel = hasCuratedLabel ? renderedValue : extractPrimaryLabel(rawValue);
    const wrapper = document.createElement('span');
    wrapper.className = 'fv5-option-value';
    const title = document.createElement('strong');
    title.textContent = primaryLabel;
    wrapper.appendChild(title);
    const pack = extractPackLabel(rawValue);
    if (pack) {
      const meta = document.createElement('small');
      meta.textContent = pack;
      wrapper.appendChild(meta);
    }
    if (textSpan) textSpan.remove();
    if (swatch) swatch.classList.add('fv5-option-value__swatch');
    label.appendChild(wrapper);
    input.dataset.displayValue = hasCuratedLabel ? primaryLabel : formatSelectedValue(kind, rawValue);
    if (hasCuratedLabel) input.dataset.fvCuratedLabel = 'true';
    group.dataset.fv5OptionKind = kind;
  };

  const initOptionPanels = () => {
    qa(document, '.fv3-option[data-fv3-option-group]').forEach((group, index, allGroups) => {
      if (group.dataset.fv5Ready) return;
      group.dataset.fv5Ready = 'true';
      group.classList.add('fv5-option-enhanced');
      if (index === 0) group.classList.add('is-open');

      const legend = q(group, 'legend');
      const valuesPanel = q(group, '.fv3-option__values');
      const selectedNode = q(group, '[data-fv3-selected-value]');
      const rawLabel = (legend?.childNodes?.[0]?.textContent || legend?.textContent || 'Choose option').replace(':', '').trim();
      const values = qa(group, 'input[data-fv3-option]').map((input) => input.value || '');
      const kind = inferOptionKind(rawLabel, values);
      qa(group, 'input[data-fv3-option]').forEach((input) => decorateOptionLabel(group, input, kind));
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fv5-option-toggle';
      if (valuesPanel) {
        const productKey = group.closest('[data-fv3-product]')?.dataset.sectionId || 'product';
        valuesPanel.id ||= `FuravoraOptionPanel-${productKey}-${index + 1}`;
        button.setAttribute('aria-controls', valuesPanel.id);
      }
      button.setAttribute('aria-expanded', String(group.classList.contains('is-open')));
      button.innerHTML = `<span class="fv5-option-toggle__icon fv5-option-toggle__icon--${kind}" aria-hidden="true">${iconMarkup(kind)}</span><span class="fv5-option-toggle__copy"><small>${optionHeading(kind, rawLabel)}</small><strong data-fv5-option-selected></strong></span><span class="fv5-option-toggle__chevron" aria-hidden="true">⌄</span>`;
      legend?.after(button);
      const selectedText = q(button, '[data-fv5-option-selected]');

      const syncPanelAccess = (expanded) => {
        const activePanel = q(group, '.fv6-option-sections') || valuesPanel;
        if (!activePanel) return;
        activePanel.toggleAttribute('inert', !expanded);
        activePanel.setAttribute('aria-hidden', String(!expanded));
        if (activePanel.id) button.setAttribute('aria-controls', activePanel.id);
        if (activePanel !== valuesPanel && valuesPanel) {
          valuesPanel.setAttribute('inert', '');
          valuesPanel.setAttribute('aria-hidden', 'true');
        }
      };

      const sync = () => {
        const checked = q(group, 'input[data-fv3-option]:checked');
        selectedText.textContent = checked?.dataset.displayValue || formatSelectedValue(kind, checked?.value || '') || selectedNode?.textContent?.trim() || checked?.value || 'Choose';
      };
      sync();
      syncPanelAccess(group.classList.contains('is-open'));

      button.addEventListener('click', () => {
        const willOpen = !group.classList.contains('is-open');
        group.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
        syncPanelAccess(willOpen);
      });

      group.addEventListener('change', (event) => {
        if (!event.target.matches('input[data-fv3-option]')) return;
        window.setTimeout(sync, 20);
        const currentIndex = allGroups.indexOf(group);
        const next = allGroups[currentIndex + 1];
        if (next && !next.classList.contains('is-open')) {
          window.setTimeout(() => {
            group.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
            syncPanelAccess(false);
            next.classList.add('is-open');
            const nextToggle = q(next, '.fv5-option-toggle');
            nextToggle?.setAttribute('aria-expanded', 'true');
            const nextPanel = q(next, '.fv6-option-sections') || q(next, '.fv3-option__values');
            nextPanel?.removeAttribute('inert');
            nextPanel?.setAttribute('aria-hidden', 'false');
            nextToggle?.focus({ preventScroll: true });
          }, 220);
        }
      });

      if (selectedNode) new MutationObserver(sync).observe(selectedNode, { childList: true, characterData: true, subtree: true });
    });
  };

  const initAccordionGroups = () => {
    qa(document, '.fv5-footer__nav, .fv5-store-info__accordions').forEach((group) => {
      if (group.dataset.fv5Accordion) return;
      group.dataset.fv5Accordion = 'true';
      qa(group, 'details').forEach((detail) => detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        qa(group, 'details').forEach((other) => { if (other !== detail) other.open = false; });
      }));
    });
  };

  const init = () => {
    initTapFeedback();
    initSearch();
    initOptionPanels();
    initAccordionGroups();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => {
    initSearch();
    initOptionPanels();
    initAccordionGroups();
  });
})();
